<template>
  <div>
    <v-card>
      <v-card-title>Tylko do odczytu, trwają prace nad widokiem</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="10" offset="1">
            <v-btn class="mr-2" @click="type = 'day'">Dzień</v-btn>
            <v-btn class="mr-2" @click="type = 'week'">Tydzien</v-btn>
            <v-btn class="mr-2" @click="type = 'month'">Miesiąc</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex" cols="1">
            <v-btn
              class="ml-auto mr-auto"
              icon
              x-large
              @click="$refs.calendar.prev()"
            >
              <v-icon large>fa-arrow-left</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <v-calendar
              ref="calendar"
              v-model="value"
              :events="holidays"
              :type="type"
              :event-more="false"
              @click:event="clickEvent"
            >
            </v-calendar>
          </v-col>
          <v-col class="d-flex" cols="1">
            <v-btn
              class="ml-auto mr-auto"
              icon
              x-large
              @click="$refs.calendar.next()"
            >
              <v-icon large>fa-arrow-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" width="600" persistent>
      <v-card v-if="selectedEvent">
        <v-card-title>Święto</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model="selectedEvent.name"
                label="Nazwa"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="selectedEvent.start"
                label="Data i godzina rozpoczęcia"
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="1">
              <v-menu
                ref="startMenu"
                v-model="startMenu"
                :close-on-content-click="false"
                :return-value="selectedEvent.start"
                min-width="290px"
                offset-y
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" class="ma-auto" icon>
                    <v-icon>fa-calendar-alt</v-icon>
                  </v-btn>
                </template>
                <v-date-picker
                  v-model="selectedEvent.start"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="selectedEvent.end"
                label="data zakończenia"
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="1">
              <v-menu
                ref="endMenu"
                v-model="endMenu"
                :close-on-content-click="false"
                :return-value="selectedEvent.end"
                min-width="290px"
                offset-y
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" class="ma-auto" icon>
                    <v-icon>fa-calendar-alt</v-icon>
                  </v-btn>
                </template>
                <v-date-picker v-model="selectedEvent.end" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-checkbox
                v-model="selectedEvent.allDay"
                label="Cały dzień"
              ></v-checkbox>
            </v-col>
          </v-row>
          W tej chwili przyciski nic nie robią
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary"
            ><v-icon class="mr-2">fa-save</v-icon>Zapisz</v-btn
          >
          <v-btn color="secondary" @click="cancelEdit"
            ><v-icon class="mr-2">fa-times</v-icon>Anuluj</v-btn
          >
          <v-spacer> </v-spacer>
          <v-btn color="error"
            ><v-icon class="mr-2">fa-trash</v-icon>Usuń</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    companyId: Number,
  },
  data() {
    return {
      type: "month",
      value: "",
      holidays: [],
      dialog: false,
      selectedEvent: null,
      startMenu: false,
      endMenu: false,
    };
  },
  methods: {
    clickDate(arg) {},
    clickDay(arg) {},
    clickTime(arg) {},
    clickMore(arg) {},
    clickEvent(arg) {
      console.log("clickEvent", arg);
      this.selectedEvent = arg.event;
      this.dialog = true;
    },
    saveEdit() {},
    cancelEdit() {
      this.dialog = false;
      this.selectedEvent = null;
      this.downloadData();
    },
    downloadData() {
      let vm = this;
      this.$http
        .get("Configuration/GetHolidaysForCompany?id=" + this.companyId)
        .then((response) => {
          vm.holidays = response.data.map((el) => {
            if (!el.isAllDay) {
              return {
                name: el.title,
                start: el.from,
                end: el.to,
                allDay: el.isAllDay,
              };
            } else {
              return {
                name: el.title,
                start: vm.moment(el.from).format("YYYY-MM-DD"),
                end: vm.moment(el.from).format("YYYY-MM-DD"),
                allDay: el.isAllDay,
              };
            }
          });
        });
    },
  },
  mounted() {
    this.downloadData();
  },
};
</script>
